import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import createStore from "../../../shared/utils/createStore"
import ProductsCalendarWidget from './ProductsCalendarWidget'
import rootReducer, { initializeView } from './duck'

$(document).ready(function() {
  $(".js-ProductsCalendarWidget").each(function(i, element) {
    const products = JSON.parse(element.getAttribute("data-products"))
    const onSlotClickActionType = element.getAttribute("data-on-slot-click-action-type") || "show_product"

    const store = createStore(rootReducer)
    const app = {
      store,
      get state() { return store.getState() }
    }
    window.app = app

    store.dispatch(initializeView({ products, onSlotClickActionType }))

    render(
      <Provider store={store}>
        <ProductsCalendarWidget />
      </Provider>,
      element
    )
  })
})



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/ProductsCalendarWidget/init.jsx